/*
  Find Your Knife quiz (theme-built). Markup, copy and the in-stock knife data come from
  sections/acre-knife-quiz.liquid; the copy is edited in the theme editor. This file runs the
  steps and picks one knife.

  Scoring, per in-stock knife (best matching variant for Signature):
    knife style vs. "What do you cut most?"  weight 0-3 x 4 (see CUTS below)
    steel vs. care answer                    +3 match, -4 mismatch, 0 if unknown or "Not sure"
    price vs. budget                         +4 in range, -3 per range away, 0 for "best fit"
    Macrum on kitchen answers                +1 (our everyday line)
  Kitchen answers only see Indoor knives, outdoor answers only Outdoor knives (custom.blade_use).
  Ties go to the lower price.
  With a price range chosen, the pick is the best knife in that range that suits the job and steel
  answers. If none does, the closest fit outside it shows with the "Price miss line" and a red X.
*/
(function () {
  var CARBON = /carbon|52100|26c3|apex|cruforge|1095|1084|15n20|\bw2\b|\bo1\b|aogami|shirogami/i;

  // "why" is the fallback reason; the shown text is set on each answer in the theme editor.
  var CUTS = {
    everything: { why: 'An all-rounder for most jobs on the cutting board.', styles: { chef: 3, gyuto: 3, santoku: 2, bunka: 2, kiritsuke: 2, funayuki: 2 } },
    veg: { why: 'Shaped for chopping vegetables and herbs.', styles: { nakiri: 3, santoku: 3, bunka: 3, 'chinese-cleaver': 2, cleaver: 1, chef: 1, gyuto: 1, kiritsuke: 1 } },
    protein: { why: 'Long enough for clean slices through meat and fish.', styles: { sujihiki: 3, slicer: 3, yanagiba: 3, gyuto: 2, boning: 2, fillet: 2, deba: 2, butakiri: 2, chef: 1 } },
    small: { why: 'Small and precise for work in your hand.', styles: { paring: 3, petty: 3, utility: 3, funayuki: 1 } },
    camp: { why: 'A strong tip and belly for camp and field work.', styles: { 'drop-point': 3, 'clip-point': 3, camp: 3, 'trailing-point': 2, puukko: 2, pattada: 2, recurve: 1, boning: 1 } },
    fish: { why: 'Slim and nimble for fish and small game.', styles: { 'bird-trout': 3, fillet: 3, boning: 2, 'drop-point': 1 } },
    carry: { why: 'Compact and controlled for everyday jobs.', styles: { wharncliffe: 3, sheepsfoot: 3, tanto: 3, recurve: 2, hawksbill: 2, kiridashi: 2, 'drop-point': 1, pattada: 1 } },
    forage: { why: 'Made for harvesting in the field.', styles: { forager: 3, hawksbill: 2, pattada: 1 } }
  };

  // Styles without their own drawing borrow a close one.
  var DRAW_FALLBACK = { sujihiki: 'slicer', yanagiba: 'slicer', utility: 'petty' };

  // "What's a ...?" reads better with "knife" on these style names.
  var KNIFE_NAMES = { chef: 'chef knife', paring: 'paring knife', utility: 'utility knife', petty: 'petty knife', boning: 'boning knife', camp: 'camp knife', 'bird-trout': 'bird and trout knife', fillet: 'fillet knife' };

  var ORDER = { where: 1, cut_kitchen: 2, cut_outdoor: 2, care: 3, budget: 4 };

  var ICONS = {
    check: '<svg class="acre-svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    sharpening: '<svg class="acre-svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 16.5 7 9h10l3.5 7.5Z"/><path d="M7 9l2.5-4h5L17 9"/></svg>',
    truck: '<svg class="acre-svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 6.5h11v9.5H3Z"/><path d="M14 9.5h3.8l3.2 3.4V16H14Z"/><circle cx="7" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/></svg>',
    engraving: '<svg class="acre-svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15.5 4.5l4 4L9 19l-5 1 1-5Z"/><path d="m13.5 6.5 4 4"/></svg>',
    cross: '<svg class="acre-svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"/></svg>'
  };

  var EDITING = !!(window.Shopify && window.Shopify.designMode);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function joinList(text) {
    var parts = String(text || '').split(',').map(function (p) { return p.trim().toLowerCase(); }).filter(Boolean);
    if (parts.length < 2) return parts.join('');
    if (parts.length === 2) return parts.join(' and ');
    return parts.slice(0, -1).join(', ') + ', and ' + parts[parts.length - 1];
  }

  function firstSentences(text, count) {
    var found = String(text || '').replace(/\s+/g, ' ').trim().match(/[^.!?]+[.!?]+(\s|$)/g);
    if (!found) return String(text || '').trim();
    return found.slice(0, count).join('').trim();
  }

  function init(root) {
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var data;
    try {
      data = JSON.parse(root.querySelector('[data-quiz-data]').textContent);
    } catch (err) {
      console.error('Knife quiz: could not read the knife data.', err);
      return;
    }
    var copy = {};
    try {
      copy = JSON.parse(root.querySelector('[data-quiz-copy]').textContent) || {};
    } catch (err) {}
    var knives = data.knives || [];
    var styles = data.styles || {};
    var state = {};
    var trail = [];
    var current = 'intro';
    var uid = 0;
    var progress = root.querySelector('[data-quiz-progress]');
    var results = root.querySelector('[data-quiz-results]');

    /* Results copy from the section settings, with the original wording if a field is cleared. */
    function copyFor(key, fallback) {
      return copy[key] ? String(copy[key]) : fallback;
    }
    // Brand icons for "Included with your knife", from <template data-quiz-icon> in the section;
    // the line icons in ICONS are the fallback.
    function perkIcon(key) {
      var t = root.querySelector('template[data-quiz-icon="' + key + '"]');
      return t && t.innerHTML.trim() ? t.innerHTML : ICONS[key];
    }
    // Every link in the quiz opens a new tab, so going back never restarts the quiz.
    function newTabLinks(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('a[href]'), function (a) {
        a.target = '_blank';
        a.rel = 'noopener';
      });
    }
    // Reason for a "What do you cut most?" answer, set on its question block.
    function cutWhy(key) {
      var option = root.querySelector('.acre-quiz__option[data-key="cut"][data-value="' + key + '"]');
      return (option && option.getAttribute('data-why')) || (CUTS[key] ? CUTS[key].why : '');
    }

    /* Knife drawings: cloned from <template data-profile> with unique ids, so gradients
       never point at a copy inside a hidden step. */
    function hasDrawing(key) {
      var t = key && root.querySelector('template[data-profile="' + key + '"]');
      return !!(t && t.content.querySelector('svg'));
    }
    function drawingKey(key) {
      if (hasDrawing(key)) return key;
      if (DRAW_FALLBACK[key] && hasDrawing(DRAW_FALLBACK[key])) return DRAW_FALLBACK[key];
      return '';
    }
    function drawing(key) {
      var t = root.querySelector('template[data-profile="' + key + '"]');
      var svg = t && t.content.querySelector('svg');
      if (!svg) return null;
      svg = svg.cloneNode(true);
      var suffix = '-quiz' + (++uid);
      var nodes = svg.querySelectorAll('*');
      Array.prototype.forEach.call(svg.querySelectorAll('[id]'), function (el) {
        var oldId = el.id, newId = oldId + suffix;
        el.id = newId;
        Array.prototype.forEach.call(nodes, function (n) {
          Array.prototype.forEach.call(n.attributes, function (a) {
            if (a.value.indexOf('#' + oldId) > -1) {
              n.setAttribute(a.name, a.value.split('url(#' + oldId + ')').join('url(#' + newId + ')').replace(new RegExp('^#' + oldId + '$'), '#' + newId));
            }
          });
        });
      });
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      return svg;
    }
    function fillDrawings(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-draw]'), function (el) {
        if (el.firstChild) return;
        var key = drawingKey(el.getAttribute('data-draw'));
        var svg = key && drawing(key);
        if (svg) el.appendChild(svg);
        else el.hidden = true;
      });
    }

    /* Steps */
    function nextAfter(name) {
      if (name === 'intro') return 'where';
      if (name === 'where') return state.where === 'outdoor' ? 'cut_outdoor' : 'cut_kitchen';
      if (name === 'cut_kitchen' || name === 'cut_outdoor') return 'care';
      if (name === 'care') return 'budget';
      return 'results';
    }
    // quiet: no scrolling or focus, for the theme editor so typing in the sidebar isn't interrupted.
    function show(name, quiet) {
      current = name;
      if (EDITING) window.acreQuizEditing = { step: name, state: state };
      Array.prototype.forEach.call(root.querySelectorAll('[data-step]'), function (s) {
        s.hidden = s.getAttribute('data-step') !== name;
      });
      var n = ORDER[name];
      if (n) {
        progress.hidden = false;
        progress.querySelector('[data-quiz-count]').textContent = 'Question ' + n + ' of 4';
        progress.querySelector('[data-quiz-bar]').style.width = (n / 4 * 100) + '%';
      } else {
        progress.hidden = true;
      }
      if (name === 'results') renderResults();
      if (quiet) return;
      var step = root.querySelector('[data-step="' + name + '"]');
      var head = step && step.querySelector('[tabindex="-1"]');
      var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
      if (window.pageYOffset > top) window.scrollTo(0, Math.max(top, 0));
      if (head) head.focus({ preventScroll: true });
    }
    function go(name) {
      trail.push(current);
      show(name);
    }
    function back() {
      show(trail.length ? trail.pop() : 'intro');
    }
    function restart() {
      state = {};
      trail = [];
      Array.prototype.forEach.call(root.querySelectorAll('.acre-quiz__option'), function (o) { o.setAttribute('aria-pressed', 'false'); });
      show('intro');
    }

    /* Matching */
    function steelOf(v) {
      var label = String(v.st || v.bm || '').trim();
      var text = (String(v.st || '') + ' ' + String(v.bm || '')).trim();
      if (!text) return { cls: 'unknown', label: '' };
      return { cls: CARBON.test(text) ? 'carbon' : 'stainless', label: label };
    }
    function handleOf(v) {
      if (!v.h) return '';
      return Array.isArray(v.h) ? v.h.join(', ') : String(v.h);
    }
    function careScore(cls) {
      if (state.care === 'stainless') return cls === 'stainless' ? 3 : (cls === 'carbon' ? -4 : 0);
      if (state.care === 'carbon') return cls === 'carbon' ? 3 : (cls === 'stainless' ? -4 : 0);
      return 0;
    }
    function budgetScore(price) {
      var b = state.budget;
      if (!b || b === 'any') return 0;
      var bucket = price < 400 ? 0 : (price < 800 ? 1 : 2);
      var want = b === 'low' ? 0 : (b === 'mid' ? 1 : 2);
      return bucket === want ? 4 : -3 * Math.abs(bucket - want);
    }
    function rank() {
      var cut = CUTS[state.cut] || { styles: {} };
      var wantOutdoor = state.where === 'outdoor';
      var list = [];
      knives.forEach(function (k) {
        if ((k.o === 'outdoor') !== wantOutdoor) return;
        var best = null, bestScore = -1e9;
        (k.v || []).forEach(function (v) {
          var s = careScore(steelOf(v).cls) + budgetScore(v.p / 100);
          if (s > bestScore || (s === bestScore && best && v.p < best.p)) { bestScore = s; best = v; }
        });
        if (!best) return;
        var w = cut.styles[k.s] || 0;
        var score = w * 4 + bestScore + (k.l === 'Macrum' && !wantOutdoor ? 1 : 0);
        list.push({ k: k, v: best, w: w, score: score });
      });
      list.sort(function (a, b) { return (b.score - a.score) || (b.w - a.w) || (a.v.p - b.v.p); });
      return list;
    }
    function alternates(list, hero) {
      var out = [], perMaker = {};
      perMaker[hero.k.m || hero.k.l] = 1;
      function take(test) {
        list.forEach(function (c) {
          if (out.length >= 3 || c.k === hero.k || out.indexOf(c) > -1 || !test(c)) return;
          var maker = c.k.m || c.k.l;
          if ((perMaker[maker] || 0) >= 2) return;
          perMaker[maker] = (perMaker[maker] || 0) + 1;
          out.push(c);
        });
      }
      function careOk(c) { return careScore(steelOf(c.v).cls) >= 0; }
      function budgetOk(c) { return budgetScore(c.v.p / 100) >= 0; }
      // Same job first, then the steel and budget answers, loosening only if needed.
      take(function (c) { return c.w > 0 && careOk(c) && budgetOk(c); });
      take(function (c) { return c.w > 0 && careOk(c); });
      take(function (c) { return c.w > 0; });
      take(function () { return true; });
      return out;
    }
    // With a price range chosen, the pick is the best knife in that range that suits the job and
    // steel answers. Only when there is none does the closest fit outside it win.
    function pickHero(list) {
      if (!state.budget || state.budget === 'any') return list[0];
      for (var i = 0; i < list.length; i++) {
        var c = list[i];
        if (c.w > 0 && careScore(steelOf(c.v).cls) >= 0 && budgetScore(c.v.p / 100) > 0) return c;
      }
      return list[0];
    }
    function missedBudget(v) {
      return !!state.budget && state.budget !== 'any' && budgetScore(v.p / 100) <= 0;
    }

    /* Results */
    // The line (Macrum, Signature, Special Edition) on one line, "by <maker>" on the next.
    function lineLabel(k) {
      var by = k.l === 'Macrum' ? 'Our everyday line' : (k.m ? 'by ' + k.m : '');
      return '<span class="acre-quiz__line-name">' + esc(k.l) + '</span>' +
        (by ? '<span class="acre-quiz__line-by">' + esc(by) + '</span>' : '');
    }
    function linkFor(c) {
      return c.k.u + (c.k.l === 'Signature' || (c.k.v || []).length > 1 ? '?variant=' + c.v.id : '');
    }
    function reasons(c) {
      var k = c.k, v = c.v, out = [];
      var style = styles[k.s];
      var cut = CUTS[state.cut];
      if (style && style.n && c.w > 0) {
        var uses = joinList(style.u);
        var circular = uses && uses.indexOf(style.n.toLowerCase().slice(0, 5)) > -1;
        out.push(uses && !circular ? esc(style.n) + ': made for ' + esc(uses) + '.' : esc(cut ? cutWhy(state.cut) : ''));
      } else if (cut) {
        out.push(esc(cutWhy(state.cut)));
      }
      var steel = steelOf(v);
      var lead = steel.label && !/carbon|stainless/i.test(steel.label) ? esc(steel.label) + ': ' : '';
      if (steel.cls === 'carbon') out.push((lead ? lead + 'carbon' : 'Carbon') + ' steel that takes a very fine edge. Dry it after washing.');
      if (steel.cls === 'stainless') out.push((lead ? lead + 'stainless' : 'Stainless') + ' steel that resists rust and stains.');
      if (k.l === 'Macrum') out.push('Part of Macrum, our everyday line, with complimentary engraving.');
      else if (k.l === 'Signature' && k.m === 'Adam Andrews') out.push(k.m ? 'From ' + esc(k.m) + '’ Signature line.' : 'From one of our Signature lines.');
      else if (k.l === 'Signature' && k.m !== 'Adam Andrews') out.push(k.m ? 'From ' + esc(k.m) + '’s Signature line.' : 'From one of our Signature lines.');
      else if (k.l === 'Special Edition' && k.m === 'Adam Andrews') out.push((k.m ? 'One of ' + esc(k.m) + '’ Special Editions' : 'A Special Edition') + ': limited runs and one-of-a-kind knives.');
      else out.push((k.m ? 'One of ' + esc(k.m) + '’s Special Editions' : 'A Special Edition') + ': limited runs and one-of-a-kind knives.');
      if (state.budget && state.budget !== 'any' && budgetScore(v.p / 100) > 0) out.push('Fits your budget at ' + esc(v.pf) + '.');
      return out.filter(Boolean);
    }
    function matchCard(c) {
      var k = c.k, v = c.v, url = linkFor(c), img = v.img || k.i;
      var steel = steelOf(v), spec = [];
      if (steel.label) spec.push(/steel/i.test(steel.label) ? steel.label : steel.label + ' steel');
      var handle = handleOf(v);
      if (handle) spec.push(handle + ' handle');
      return '<div class="acre-quiz__match">' +
        '<a class="acre-quiz__match-img" href="' + esc(url) + '"><img src="' + esc(img) + '" alt="' + esc(k.t) + '" loading="lazy"></a>' +
        '<div class="acre-quiz__match-body">' +
          '<p class="acre-quiz__line">' + lineLabel(k) + '</p>' +
          '<h3 class="acre-quiz__match-title"><a href="' + esc(url) + '">' + esc(k.t) + '</a></h3>' +
          (spec.length ? '<p class="acre-quiz__spec">' + esc(spec.join(', ')) + '</p>' : '') +
          '<p class="acre-quiz__price">' + esc(v.pf) + '</p>' +
          (missedBudget(v) ? '<p class="acre-quiz__miss">' + ICONS.cross + '<span>' + esc(copyFor('budget_miss', 'No matches for your price point. Here’s our closest fit.')) + '</span></p>' : '') +
          '<p class="acre-quiz__why-label">' + esc(copyFor('why_label', 'Why it suits you')) + '</p>' +
          '<ul class="acre-quiz__why">' + reasons(c).map(function (r) { return '<li>' + ICONS.check + '<span>' + r + '</span></li>'; }).join('') + '</ul>' +
          '<a class="btn acre-quiz__cta" href="' + esc(url) + '">' + esc(copyFor('cta', 'See this knife')) + '</a>' +
        '</div>' +
      '</div>';
    }
    function styleCard(key) {
      var s = styles[key];
      if (!s || !s.n) return '';
      var name = KNIFE_NAMES[key] || s.n.toLowerCase();
      var article = /^[aeio]/.test(name) ? 'an' : 'a';
      var draw = drawingKey(key);
      var desc = firstSentences(s.d, 2);
      var facts = [];
      if (s.u) facts.push('<span><strong>Uses</strong>' + esc(s.u) + '</span>');
      if (s.b) facts.push('<span><strong>Best for</strong>' + esc(s.b) + '</span>');
      return '<div class="acre-quiz__style">' +
        (draw ? '<div class="acre-quiz__style-draw" data-draw="' + esc(draw) + '"></div>' : '') +
        '<div>' +
          '<h3 class="acre-quiz__h3">What’s ' + article + ' ' + esc(name) + '?</h3>' +
          (desc ? '<p>' + esc(desc) + '</p>' : '') +
          (facts.length ? '<p class="acre-quiz__facts">' + facts.join('') + '</p>' : '') +
          '<a class="acre-quiz__link" href="' + esc(root.getAttribute('data-glossary') + '#' + key) + '">More knife styles in our glossary</a>' +
        '</div>' +
      '</div>';
    }
    function altCard(c) {
      var img = c.v.img || c.k.i;
      return '<a class="acre-quiz__alt" href="' + esc(linkFor(c)) + '">' +
        '<img src="' + esc(img) + '" alt="" loading="lazy">' +
        '<span class="acre-quiz__alt-text">' +
          '<span class="acre-quiz__line">' + lineLabel(c.k) + '</span>' +
          '<span class="acre-quiz__alt-title">' + esc(c.k.t) + '</span>' +
          '<span class="acre-quiz__alt-price">' + esc(c.v.pf) + '</span>' +
        '</span>' +
      '</a>';
    }
    function perks(c) {
      var items = [
        ['sharpening', copyFor('sharpening_title', 'Lifetime sharpening'), esc(copyFor('sharpening', 'Bring it to Acre Forge or mail it in, and we’ll sharpen it for the life of the blade.')) + ' <a href="' + esc(root.getAttribute('data-sharpening-url')) + '">How it works</a>'],
        ['truck', copyFor('shipping_title', 'Free domestic shipping'), '']
      ];
      if (c.k.l === 'Macrum') items.push(['engraving', copyFor('engraving_title', 'Complimentary engraving'), esc(copyFor('engraving', 'Up to three characters on the handle tab.'))]);
      return '<h3 class="acre-quiz__h3">' + esc(copyFor('perks_heading', 'Included with your knife')) + '</h3>' +
        '<ul class="acre-quiz__perks">' + items.map(function (p) {
          return '<li class="acre-quiz__perk">' + perkIcon(p[0]) + '<span><strong>' + esc(p[1]) + '</strong>' + p[2] + '</span></li>';
        }).join('') + '</ul>';
    }
    function renderResults() {
      var list = rank();
      var appointment = esc(root.getAttribute('data-appointment'));
      if (!list.length) {
        results.innerHTML =
          '<h2 class="acre-quiz__q" tabindex="-1">' + esc(copyFor('none_heading', 'Let’s talk it through')) + '</h2>' +
          '<p class="acre-quiz__lead">' + esc(copyFor('none_text', 'We don’t have a knife in stock for that mix right now. Book a virtual appointment and we’ll help you choose.')) + '</p>' +
          '<div class="acre-quiz__end"><a class="btn" href="' + appointment + '">' + esc(copyFor('none_button', 'Book a virtual appointment')) + '</a>' +
          '<button type="button" class="acre-quiz__back" data-quiz-restart>Start over</button></div>';
        newTabLinks(results);
        return;
      }
      var hero = pickHero(list);
      var alts = alternates(list, hero);
      results.innerHTML =
        '<div class="acre-quiz__results-head">' +
          '<h2 class="acre-quiz__q" tabindex="-1">' + esc(copyFor('results_heading', 'Your match')) + '</h2>' +
          '<button type="button" class="acre-quiz__back" data-quiz-restart>Start over</button>' +
        '</div>' +
        matchCard(hero) +
        styleCard(hero.k.s) +
        (alts.length ? '<h3 class="acre-quiz__h3">' + esc(copyFor('alts_heading', 'You might also like')) + '</h3><div class="acre-quiz__alts">' + alts.map(altCard).join('') + '</div>' : '') +
        perks(hero) +
        '<div class="acre-quiz__end">' +
          '<p>' + esc(copyFor('end_text', 'Want a second opinion?')) + ' <a href="' + appointment + '">' + esc(copyFor('end_link', 'Book a virtual appointment with our team.')) + '</a></p>' +
        '</div>';
      fillDrawings(results);
      newTabLinks(results);
    }

    /* Events */
    root.addEventListener('click', function (evt) {
      var option = evt.target.closest('.acre-quiz__option');
      if (option && root.contains(option)) {
        state[option.getAttribute('data-key')] = option.getAttribute('data-value');
        Array.prototype.forEach.call(option.parentNode.querySelectorAll('.acre-quiz__option'), function (o) {
          o.setAttribute('aria-pressed', o === option ? 'true' : 'false');
        });
        var stepName = option.closest('[data-step]').getAttribute('data-step');
        setTimeout(function () { go(nextAfter(stepName)); }, 160);
        return;
      }
      if (evt.target.closest('[data-quiz-start]')) { go('where'); return; }
      if (evt.target.closest('[data-quiz-back]')) { back(); return; }
      if (evt.target.closest('[data-quiz-restart]')) { restart(); }
    });

    fillDrawings(root);
    newTabLinks(root);

    /* Theme editor: selecting a question block shows that question, and the step on screen
       stays put when the preview reloads after an edit. */
    if (EDITING) {
      var editing = window.acreQuizEditing;
      if (editing && editing.step !== 'intro') {
        state = editing.state || {};
        show(editing.step, true);
      }
      document.addEventListener('shopify:block:select', function (evt) {
        var step = evt.target.closest && evt.target.closest('[data-step]');
        if (step && root.contains(step)) show(step.getAttribute('data-step'), true);
      });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-acre-quiz]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
